/** Strings for the livechat page header: tools menu, agent menu, test mode and availability hints. */
export const translationLivechat_sv_header = {
  livechatToolsMenuLabel: "Inställningar och verktyg",
  livechatSettingsHint: "Tillgänglighet, widget, översättning, routing, inaktiva chattar och data",
  livechatCannedResponsesHint: "Hantera sparade svar",
  livechatGroupsHint: "Välj vem som tar emot routade chattar",
  livechatTestMode: "Testläge",
  livechatTestModeHint: "Visa bara chattar från testportaler",
  livechatTestModeBarTitle: "Testläge.",
  livechatTestModeBarText:
    "Du ser bara chattar från testportaler. Livechattar fortsätter att komma in i livekön.",
  livechatBackToLive: "Tillbaka till live",
  livechatAgentMenuLabel: "Din agentprofil och notifikationer",
  livechatAgentProfileHint: "Namn, bild och språk som besökare ser",
  livechatAgentProfileHintAllChatbots: "Namn, bild och språk som besökare ser på alla chatbotar",
  livechatNotifyMe: "Meddela mig",
  livechatPopupShort: "Popup-meddelanden",
  livechatPopupHint: "En avisering vid ny livechat-aktivitet",
  livechatOtherAgentsShort: "Chattar som hanteras av andra agenter",
  livechatOtherAgentsHint: "När avstängt aviseras du bara om dina egna och otilldelade chattar",
  livechatGoOnlineHint: "Även utanför öppettiderna",
  livechatGoOfflineHint: "Besökare ser kontaktformuläret",
  livechatUseScheduleHint: "Följ varje chatbots öppettider",
  livechatAvailabilityOneChatbot: "Ändra en chatbot",
  livechatEditOpeningHours: "Redigera öppettider",
};
